import { render, staticRenderFns } from "./MarketCartButton.vue?vue&type=template&id=31caf53b&"
import script from "./MarketCartButton.vue?vue&type=script&lang=js&"
export * from "./MarketCartButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports